import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import BseRepository from '../../../repositories/BseRepository';
import BseDataRepository from '../../../../data/repositories/BseDataRepository';

export default function* execute(action: any): any {
  try {
    const { requestId } = action;
    yield put({ type: Types.GET_FORM_BSE_REQUEST });
    const bseRepository: BseRepository = new BseDataRepository();
    const bseResponse = yield call(bseRepository.getFormBse, requestId);
    if (!bseResponse) {
      yield put({
        type: Types.GET_FORM_BSE_FAILURE,
        error: true
      });
      return;
    }

    yield put({
      type: Types.GET_FORM_BSE_SUCCESS,
      data: bseResponse?.fields,
      documents: bseResponse?.documents,
      dbToken: bseResponse?.tokenDrop
    });
  } catch (error) {
    yield put({
      type: Types.GET_FORM_BSE_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos.'
    });
  }
}
